export const paymentModalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 2,
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    },
  },
  dialogTitle: {
    padding: '24px 24px 16px 24px',
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  titleText: {
    fontWeight: 600,
    color: 'text.primary',
  },
  closeButton: {
    color: 'text.secondary',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
  },
  paymentIcon: {
    color: 'primary.main',
    fontSize: 24,
  },
  dialogContent: {
    padding: '24px',
  },
  messageText: {
    marginBottom: 2,
    color: 'text.primary',
  },
  expenseInfoContainer: {
    marginBottom: 3,
    padding: '12px 16px',
    backgroundColor: 'action.hover',
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  expenseInfoLabel: {
    fontWeight: 500,
    color: 'text.secondary',
  },
  expenseInfoValue: {
    fontWeight: 600,
    color: 'text.primary',
  },
  textField: {
    marginTop: 2,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'divider',
      },
      '&:hover fieldset': {
        borderColor: 'primary.main',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'primary.main',
      },
    },
  },
  dialogActions: {
    padding: '16px 24px 24px 24px',
    gap: 2,
  },
  cancelButton: {
    minWidth: 100,
  },
  confirmButton: {
    minWidth: 100,
  },
};

